import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ToolTipComponent from './ToolTipComponent';

dayjs.extend(relativeTime);

export interface ContactCardProps {
  draft: {
    _id?: string;
    threatTypeName: string;
    setName: string;
    locationName: string;
    userName: string;
    updatedAt: string | Date;
    reportType: string;
    studioId: string;
    reporterInfo: {
      reporter: {
        reporterName: string;
      };
    };
    savedFor: string;
    productionId: string;
    episodeId: string;
    setId: string;
    locationId: string;
  };
}

const ContactCard: React.FC<ContactCardProps> = ({ draft }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name');

  const handleClick = () => {
    navigate(
      `/add-threat?draftId=${draft?._id}&reportType=${draft?.reportType}&name=${name}` +
        (draft?.savedFor == 'studio'
          ? `&studioId=${draft?.studioId}`
          : draft?.savedFor == 'production'
          ? `&productionId=${draft?.productionId}`
          : draft?.savedFor == 'episode'
          ? `&episodeId=${draft?.episodeId}`
          : draft?.savedFor == 'set'
          ? `&setId=${draft?.setId}`
          : draft?.savedFor == 'location'
          ? `&locationId=${draft?.locationId}`
          : ''),
    );
  };

  const { firstLocation, remainingCount, locationNames } = useMemo(() => {
    const locations = draft?.locationId as any;

    const names = locations
      ?.map((loc: any) => loc?.address?.locationName)
      ?.filter(Boolean);

    return {
      locationNames: names,
      firstLocation: names?.[0] || '',
      remainingCount: names?.length > 1 ? names.length - 1 : 0,
    };
  }, [draft?.locationId]);

  return (
    <div className="contact-card" onClick={handleClick}>
      <span className="icon-round">
        <i className="board-icon"></i>
      </span>

      <div className="d-flex flex-between align-start text border">
        <div className="name">
          <h3
            className="MuiTypography-body2 fw600 mb-6"
            title={draft?.threatTypeName}
          >
            {draft?.threatTypeName ||
              `${draft?.setName} - ${draft?.locationName}`}
          </h3>

          <p className="text-text MuiTypography-subtitle1 text_dots">
            <span>{draft?.setName}</span>
            <ToolTipComponent
              title={
                remainingCount > 0 ? locationNames.slice(1).join(', ') : ''
              }
              arrow
              theme="light"
            >
              <span
                style={{
                  cursor: remainingCount > 0 ? 'pointer' : 'default',
                }}
              >
                {firstLocation}
                {remainingCount > 0 && ` + ${remainingCount}`}
              </span>
            </ToolTipComponent>
            <span>{draft?.reporterInfo?.reporter?.reporterName}</span>
          </p>
        </div>

        <div className="text-right">
          <p className="text-text MuiTypography-subtitle3 mb-12">
            {dayjs(draft?.updatedAt).fromNow()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
